import { render, staticRenderFns } from "./addAsin.vue?vue&type=template&id=67edf82a"
import script from "./addAsin.vue?vue&type=script&lang=js"
export * from "./addAsin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports